import { useState } from 'react'
import { EuiButton } from '@equipmentshare/ds2'
import ConfirmApprovalButtons from '../ConfirmApprovalButtons'
import ConfirmRejectionButtons from '../ConfirmRejectionButtons'

import styles from './approve-transaction-popover.module.css'

export type ApproveTransactionPopoverProps = {
	closePopover: () => void,
	transactionId: number,
}

export default function ApproveTransactionPopover( { transactionId, closePopover }: ApproveTransactionPopoverProps ) {
	const [ isConfirmingApproval, setIsConfirmingApproval ] = useState( false )
	const [ isConfirmingRejection, setIsConfirmingRejection ] = useState( false )

	const confirmApproval = () => {
		setIsConfirmingRejection( false )
		setIsConfirmingApproval( true )
	}
	const confirmReject = () => {
		setIsConfirmingApproval( false )
		setIsConfirmingRejection( true )
	}

	if ( isConfirmingApproval || isConfirmingRejection ) {
		return (
			<div className={styles.approvalPopover}>
				<h3>Are you sure?</h3>
				<div className={styles.buttonWrapper}>
					{ isConfirmingApproval && (
						<ConfirmApprovalButtons
							closePopover={closePopover}
							transactionId={transactionId}
						/>
					)}
					{ isConfirmingRejection && (
						<ConfirmRejectionButtons
							closePopover={closePopover}
							transactionId={transactionId}
						/>
					)}
				</div>
			</div>
		)
	}

	return (
		<div className={styles.approvalPopover}>
			<h3>Approve this transaction?</h3>
			<div className={styles.buttonWrapper}>
				<EuiButton
					id="reject-btn"
					color="danger"
					onClick={confirmReject}
				>
					Reject
				</EuiButton>
				<EuiButton
					id="approve-btn"
					color="success"
					onClick={confirmApproval}
				>
					Approve
				</EuiButton>
			</div>
		</div>
	)
}
